import initialState from './../../initialState';
import { Status } from './constants';

//const sortByDate = (a, b) => -(a.date < b.date) || +(a.date !== b.date);

export default (state = initialState.reserva, { type, value, response }) => {
  switch (type) {
    case 'ENCERRAR_GUIA_INTERATIVO':
      return {
        ...state,
        data: {
          ...state.data,
          unidade: '',
          data_reserva: ''
        },
        list: {
          ...state.list,
          result: state.list.result.filter(v => v.id)
        }
      };
    case 'CHANGE_DATA_RESERVAS':
      return {
        ...state,
        data: {
          ...state.data,
          [value.key]: value.value
        }
      };
    case 'LIST_RESERVAS_REQUEST':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 1
        }
      };
    case 'LIST_RESERVAS_SUCCESS':
      return {
        ...state,
        list: {
          result: response.list,
          lastModified: response.lastModified,
          fetching: 2,
          errors: []
        }
      };
    case 'LIST_RESERVAS_FAILURE':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 0,
          errors: ['Falha na obtenção da lista']
        }
      };
    case 'CREATE_RESERVAS_REQUEST':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 1,
          result: [
            {
              ...value,
              unidade: value.unidade || '????',
              status: Status.PENDENTE,
              reservado_por: 'Você'
            },
            ...state.list.result
          ]
        }
      };
    case 'CREATE_RESERVAS_FAILURE':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 0,
          result: state.list.result.filter(
            v =>
              v.id ||
              v.unidade !== value.unidade ||
              v.data_reserva !== value.data_reserva
          ),
          errors: ['Falha ao cadastrar reserva']
        }
      };
    case 'CREATE_RESERVAS_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        data: {
          ...state.data,
          unidade: '',
          data_reserva: ''
        },
        list: {
          ...state.list,
          fetching: 2,
          result: [
            {
              ...value,
              unidade: value.unidade || '0000',
              status: Status.PENDENTE,
              reservado_por: 'Você'
            },
            ...state.list.result
          ],
          errors: []
        }
      };
    case 'APROVA_RESERVAS_REQUEST':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 1
        }
      };
    case 'APROVA_RESERVAS_FAILURE':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 0,
          errors: ['Falha ao aprovar reserva']
        }
      };
    case 'APROVA_RESERVAS_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 2,
          result: [
            { ...value, status: Status.CONFIRMADA, aprovado_por: 'Você' },
            ...state.list.result.filter(
              v =>
                v.id ||
                (value &&
                  (v.unidade !== value.unidade ||
                    v.data_reserva !== value.data_reserva))
            )
          ],
          errors: []
        }
      };
    case 'CANCELA_RESERVAS_REQUEST':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 1
        }
      };
    case 'CANCELA_RESERVAS_FAILURE':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 0,
          errors: ['Falha ao cancelar reserva']
        }
      };
    case 'CANCELA_RESERVAS_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 2,
          result: [
            { ...value, status: Status.CANCELADA },
            ...state.list.result.filter(
              v =>
                v.id ||
                (value &&
                  (v.unidade !== value.unidade ||
                    v.data_reserva !== value.data_reserva))
            )
          ],
          errors: []
        }
      };
    case 'CANCELA_RESERVAS_SUCCESS_REMOCAO':
      return {
        ...state,
        list: {
          ...state.list,
          fetching: 2,
          result: state.list.result.filter(
            v =>
              v.id ||
              (value &&
                (v.unidade !== value.unidade ||
                  v.data_reserva !== value.data_reserva))
          ),
          errors: []
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reserva/reducer.js